import React from 'react';
import { Icon } from './Icon.js';
export const IconMedicalCross3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8.99998 9L9 3H15L15 9H21L21 15H15V21H9V15H3.00002L3 9H8.99998Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconMedicalCross3.js.map